"use client";

import { ReactNode } from "react";
import { motion, useReducedMotion } from "framer-motion";

type PullQuoteProps = {
  children: ReactNode;
  attribution?: string;
  className?: string;
};

export function PullQuote({ children, attribution, className }: PullQuoteProps) {
  const shouldReduceMotion = useReducedMotion();
  const Wrapper = shouldReduceMotion ? "div" : motion.div;

  return (
    <Wrapper
      className={`relative rounded-[28px] border border-border bg-card/60 p-6 text-foreground shadow-[0_20px_60px_rgba(15,23,42,0.08)] dark:text-offwhite dark:shadow-[0_30px_90px_rgba(3,4,12,0.45)] ${className ?? ""}`}
      {...(!shouldReduceMotion && {
        initial: { opacity: 0, y: 12 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, amount: 0.4 },
        transition: { duration: 0.6, ease: "easeOut" },
      })}
    >
      <div className="absolute left-4 top-4 h-12 w-1 rounded-full bg-gradient-gold" aria-hidden />
      <p className="pl-8 font-serif text-lg italic text-foreground dark:text-offwhite">{children}</p>
      {attribution && (
        <p className="mt-4 pl-8 text-xs uppercase tracking-[0.3em] text-gold-300">{attribution}</p>
      )}
      <svg
        className="absolute right-4 top-4 h-10 w-10 text-gold-300"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <path
          d="M22 16C15 16 8 22 8 30C8 40 16 44 20 44C20 48 18 52 14 54"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M46 16C39 16 32 22 32 30C32 40 40 44 44 44C44 48 42 52 38 54"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </Wrapper>
  );
}
